/**
 * Controla el diálogo de rechazar tarea.
 */
SelectListaDialogCtrl.$inject = ['$log', '$scope', '$http'];
export default function SelectListaDialogCtrl($log, $scope, $http) {
    var vm = this;
    var urlBase = Sigo.var.path + '/api/v1/usuarios/' + Sigo.user.user_id + '/listas';

    vm.model = $scope.model;
    vm.model.lista_id = null;

    cargarListas();

    function cargarListas() {
        var promesa = $http.get(urlBase);
        promesa.then(function (respuesta) {
            vm.listas = respuesta.data;
            if (vm.listas.length > 0)
                vm.model.lista_id = vm.listas[0].id;
        }, function (err) {
            $log.error('Error');
        });
    }
}